import { useMemo } from 'react'
import { groupBy } from 'ramda'

import PlainItemsSelector from 'app/common/ui-next/plain-selector/plain-items-selector'
import { sortByTitle } from 'app/common/lib/sort'
import type { SurveyFilterOption } from 'app/common/types/surveys'

import type { SurveyFilterItemProps } from './types'

export const SchoolFilter = ({
  value,
  options,
  loading,
  colorInverse,
  disabled,
  onChange,
}: SurveyFilterItemProps) => {
  const items = useMemo(() => {
    const groups = groupBy((school: SurveyFilterOption) => school.districtId || '', options.schools)
    const districts = sortByTitle(
      Object.keys(groups).map((id) => ({
        id,
        title:
          options.districts.find((district) => district.id === id)?.title ||
          (id ? `Район ${id}` : 'Без района'),
      })),
    )

    return districts.flatMap((district) => sortByTitle(groups[district.id] || []))
  }, [options.schools, options.districts])

  const handleChange = (schoolIds: Array<string>) => {
    onChange({ ...value, schoolIds })
  }

  return (
    <PlainItemsSelector
      id="surveySchool"
      label="Заведение"
      header="Выбор заведения"
      selection={value.schoolIds}
      items={items}
      multiple
      colorInverse={colorInverse}
      disabled={loading || !value.cityIds.length || disabled}
      onChange={handleChange}
      selectedAllOnEmptySelection
      skipUpperSpace
      disableAutoSelect
      doOnBadgeCrossClick="clear"
      maxViewCountBadge={3}
    />
  )
}